import { useLanguage } from "@/i18n/useLanguage";

/**
 * Syncs i18next + <html lang> with the current URL.
 * Must be rendered inside <BrowserRouter>.
 */
const LanguageSync = () => {
  useLanguage();
  return null;
};

export default LanguageSync;
